import { formatMoney } from '@aeris/money';
import { formatDocumentNumber } from "./document-number.js";
import { documentTemplate, footerBlocks, headerBlocks, } from "./receipt-template.js";
const pad = (value) => String(value).padStart(2, '0');
/** `05/08/2026 14:32`, sem `Intl` e sem surpresa de fuso. */
const stamp = (at) => `${pad(at.getDate())}/${pad(at.getMonth() + 1)}/${String(at.getFullYear())}` +
    ` ${pad(at.getHours())}:${pad(at.getMinutes())}`;
const plain = (value) => formatMoney(value, { symbol: false });
const linesBlock = (title, lines) => {
    const blocks = [{ kind: 'text', text: title, bold: true }];
    // Duas linhas por item, pelo mesmo motivo do recibo: o nome do produto é
    // maior que qualquer bobina, e a conta fica embaixo do que ela multiplicou.
    for (const line of lines) {
        blocks.push({
            kind: 'text',
            text: line.restocked === false
                ? `${line.description} (avaria)`
                : line.description,
        });
        blocks.push({
            kind: 'pair',
            label: `  ${line.quantity} ${line.unit} x ${plain(line.unitPrice)}`,
            value: plain(line.lineTotal),
        });
    }
    return blocks;
};
export const exchangeFor = (input) => {
    const title = input.kind === 'voucher' ? 'VALE' : 'TROCA';
    const doc = documentTemplate(input.template, input.kind);
    const blocks = headerBlocks({
        company: input.company,
        branchName: input.branchName,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, { kind: 'text', text: title, align: 'center', bold: true });
    if (doc.notice !== null) {
        blocks.push({ kind: 'text', text: doc.notice, align: 'center' });
    }
    blocks.push({ kind: 'rule' }, 
    // Grande, porque é lido em voz alta do outro lado do balcão.
    {
        kind: 'text',
        text: `Nº ${formatDocumentNumber(input.number)}`,
        big: true,
        bold: true,
    }, { kind: 'pair', label: 'Data', value: stamp(input.issuedAt) }, { kind: 'pair', label: 'Cliente', value: input.customerName });
    if (input.originalSaleNumber !== null) {
        blocks.push({
            kind: 'pair',
            label: input.originalSaleKind === 'order'
                ? 'Pedido de origem'
                : 'Venda de origem',
            value: `Nº ${String(input.originalSaleNumber)}`,
        });
    }
    else if (input.authorisedByName != null) {
        // F148: sem venda nossa. O papel diz de onde veio e quem aprovou.
        blocks.push({ kind: 'pair', label: 'Origem', value: 'Produto de outra loja' }, { kind: 'pair', label: 'Autorizado por', value: input.authorisedByName });
    }
    if (input.handledByName !== null) {
        blocks.push({
            kind: 'pair',
            label: 'Atendido por',
            value: input.handledByName,
        });
    }
    blocks.push({ kind: 'rule' }, ...linesBlock('DEVOLVIDO', input.returned));
    blocks.push({
        kind: 'pair',
        label: 'Total devolvido',
        value: plain(input.returnedTotal),
        bold: true,
    });
    if (input.outgoing.length > 0) {
        blocks.push({ kind: 'rule' }, ...linesBlock('LEVOU', input.outgoing));
        blocks.push({
            kind: 'pair',
            label: 'Total levado',
            value: plain(input.outgoingTotal),
            bold: true,
        });
    }
    blocks.push({ kind: 'rule' });
    if (input.voucherCredit.units !== 0n) {
        blocks.push({ kind: 'text', text: 'VALE GERADO', bold: true }, {
            kind: 'text',
            text: formatMoney(input.voucherCredit),
            align: 'right',
            big: true,
            bold: true,
        });
    }
    if (input.receivable.units !== 0n) {
        /*
         * A diferença que o cliente deve não é paga aqui.
         *
         * O trocador não recebe dinheiro (F126); o valor vira título, e o caixa
         * baixa. O papel diz isso, porque o cliente que lê "a pagar" e sai sem
         * pagar achou que estava resolvido.
         */
        blocks.push({ kind: 'text', text: 'A PAGAR NO CAIXA', bold: true }, {
            kind: 'text',
            text: formatMoney(input.receivable),
            align: 'right',
            big: true,
            bold: true,
        });
    }
    blocks.push({
        kind: 'pair',
        label: 'Saldo de vale agora',
        value: formatMoney(input.balanceAfter),
        bold: true,
    });
    if (input.note !== null && input.note.trim() !== '') {
        blocks.push({ kind: 'rule' }, { kind: 'text', text: `Obs.: ${input.note}` });
    }
    /*
     * O rodapé da loja vem ANTES do código de barras, e não no fim como no cupom.
     *
     * É onde mora, por padrão, "o vale é crédito para compras nesta loja": a
     * frase pertence ao valor que está logo acima dela, e depois das barras
     * ninguém lê.
     */
    blocks.push({ kind: 'rule' }, ...footerBlocks(input.template, input.kind), {
        kind: 'feed',
        lines: 1,
    });
    // O NÚMERO no código de barras, nunca o uuid — é o que o caixa bipa.
    if (doc.showBarcode) {
        blocks.push({
            kind: 'barcode',
            data: String(input.number),
            symbology: 'code128',
        });
    }
    blocks.push({ kind: 'feed', lines: 1 });
    if (doc.showDocumentId) {
        blocks.push({ kind: 'text', text: input.exchangeId, align: 'center' });
    }
    blocks.push({ kind: 'cut' });
    return {
        kind: input.kind,
        title: `${input.kind === 'voucher' ? 'Vale' : 'Troca'} nº ${formatDocumentNumber(input.number)}`,
        blocks,
    };
};
//# sourceMappingURL=exchange.js.map